<template>
  <v-card flat rounded="lg">
    <v-card-title class="primary--text"
      >Minhas Experiências Profissionais</v-card-title
    >
    <v-card-text>
      <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
      <experiencias-profissionais v-else />
    </v-card-text>
  </v-card>
</template>

<script>
import ExperienciasProfissionais from "@/components/inscricao/ExperienciasProfissionais.vue";
import { mapActions, mapMutations } from "vuex";

export default {
  components: { ExperienciasProfissionais },
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapMutations(["resetStateExpProf"]),
    ...mapActions(["getDadosGerais"]),
  },
  async created() {
    this.loading = true;
    this.resetStateExpProf();    
    await this.getDadosGerais();
    this.loading = false;
  },
};
</script>

<style>
</style>